/**
 * 公共方法
 */
 import { Message } from 'element-ui'

 function showMessage(_this, bool, msg){
    let type = bool ? 'success' : 'error';
    _this.$notify({
        title: '温馨提示',
        message: msg,
        type: type
      });
 }

 //删除方法Id
 function deleteById(_this, url, Id, callback){
   _this.$confirm('您确定要执行此操作吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.server.post(url, Id)
          .then((res)=>{
            let data = res.data;
            if(data.State==1){
              callback(data);
            }else {
              showMessage(_this, false, "操作失败: "+ data.ErrorMsg);
            }
          })
        }).catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
 }


 export default {
     showMessage,
     deleteById,
 }



// WEBPACK FOOTER //
// ./src/public/common.js